import { LocaleMessages } from 'vue-i18n'

const flpPtBrLocaleMessages: LocaleMessages = {
  holeriteSnapshot: {
    title: 'Demonstrativo de Pagamento',
    pluralTitle: 'Demonstrativos de Pagamento do Grupo',
    typeTitle: 'Demonstrativo de Pagamento ({type})',
    field: {
      tipoFolha: 'Tipo',
      periodo: 'Referência',
      numeroRecibo: 'Recibo',
      empregador: 'Empregador',
      colaborador: 'Trabalhador',
      vencimentos: 'Vencimentos',
      descontos: 'Descontos',
      totalVencimento: 'Total de Vencimentos',
      totalDesconto: 'Total de Descontos',
      valorLiquido: 'Valor Líquido',
      detalhes: 'Detalhes',
      salarioBase: 'Salário Contratual',
      baseCalculoIrrf: 'Base de Cálculo do IRRF',
      baseCalculoInss: 'Base de Cálculo do INSS',
      baseCalculoFgts: 'Base de Cálculo do FGTS',
      valorFgts: 'Valor do FGTS',
      observacoes: 'Observações',
      checksum: 'Checksum',
      firstViewDatetime: 'Visualizado em'
    },
    value: {
      tipoFolha: {
        FOLHA_NORMAL: 'Mensal',
        ADIANTAMENTO: 'Adiantamento',
        DECIMO_TERCEIRO: '13º Salário',
        PARTICIPACAO_LUCROS: 'Participação nos Lucros',
        FOLHA_COMPLEMENTAR: 'Complementar',
        DECIMO_TERCEIRO_COMPLEMENTAR: '13º Salário Complementar'
      }
    }
  },
  holeriteSnapshotUserContext: {
    title: 'Demonstrativo de Pagamento',
    pluralTitle: 'Demonstrativos de Pagamento'
  },
  informeRendimentoSnapshot: {
    title: 'Informe de Rendimento',
    pluralTitle: 'Informes de Rendimento do Grupo',
    yearTitle: 'Informe de Rendimento {year}',
    field: {
      ano: 'Ano Base',
      empregador: 'Empregador',
      colaborador: 'Trabalhador',
      naturezaRendimento: 'Natureza do Rendimento',
      numeroProcesso: 'Número do Processo',
      quantidadeMeses: 'Quantidade de Meses',
      grupos: 'Total de Rendimentos',
      responsavel: 'Responsável',
      checksum: 'Checksum',
      firstViewDatetime: 'Visualizado em'
    },
    value: {
      grupo: {
        1: '1 - FONTE PAGADORA PESSOA JURÍDICA OU PESSOA FÍSICA',
        2: '2 - PESSOA FÍSICA BENEFICIÁRIA DOS RENDIMENTOS',
        3: {
          0: '3 - RENDIMENTOS TRIBUTÁVEIS, DEDUÇÕES E IMPOSTO DE RENDA RETIDO NA FONTE',
          1: '01 - Total de rendimentos (inclusive férias)',
          2: '02 - Contribuição previdenciária oficial',
          3: '03 - Contribuição à previdência privada e ao fundo de aposentadoria programada individual (FAPI)',
          4: '04 - Pensão alimentícia (informar o beneficiário no campo 7)',
          5: '05 - Imposto de renda retido na fonte'
        },
        4: {
          0: '4 - RENDIMENTOS ISENTOS E NÃO TRIBUTÁVEIS',
          1: '01 - Parcela isenta dos proventos de aposentadoria, reserva, reforma e pensão (65 anos ou mais)',
          2: '02 - Diárias e ajudas de custo',
          3: '03 - Pensão, proventos de aposentadoria ou reforma por moléstia grave e aposentadoria ou reforma por acidente em serviço',
          4: '04 - Lucro e dividendo apurados a partir de 1996 por pessoa jurídica (lucro real, presumido ou arbitrado)',
          5: '05 - Valores pagos ao titular ou sócio de microempresas e empresas de pequeno porte, exceto pró-labore, aluguéis',
          6: '06 - Indenizações por rescisão de contrato de trabalho, inclusive a título de PDV e acidente de trabalho',
          7: '07 - Outros'
        },
        5: {
          0: '5 - RENDIMENTOS SUJEITOS À TRIBUTAÇÃO EXCLUSIVA (RENDIMENTO LÍQUIDO)',
          1: '01 - 13º salário',
          2: '02 - Imposto de renda retido na fonte sobre 13º salário',
          3: '03 - Outros'
        },
        6: {
          0: '6 - RENDIMENTOS RECEBIDOS ACUMULADAMENTE - Art. 12-A da Lei nº 7.713, de 1988 (TRIBUTAÇÃO EXCLUSIVA)',
          1: '01 - Total de rendimentos tributáveis (inclusive férias e 13º salário)',
          2: '02 - Exclusão: Despesas com a ação judicial',
          3: '03 - Dedução: Contribuição previdenciária oficial',
          4: '04 - Dedução: Pensão alimentícia (preencher também o quadro 7)',
          5: '05 - Imposto de renda retido na fonte',
          6: '06 - Rendimentos isentos de pensão, proventos de aposentadoria ou reforma por moléstia grave ou aposentadoria ou reforma por acidente em serviço'
        },
        7: '7 - INFORMAÇÕES COMPLEMENTARES',
        8: '8 - RESPONSÁVEL PELAS INFORMAÇÕES'
      }
    }
  },
  informeRendimentoSnapshotUserContext: {
    title: 'Informe de Rendimento',
    pluralTitle: 'Informes de Rendimento'
  },
  feriasSnapshot: {
    title: 'Aviso de Férias',
    pluralTitle: 'Avisos de Férias do Grupo',
    dateTitle: 'Aviso de Férias ({date})',
    field: {
      periodoAquisitivo: 'Período Aquisitivo',
      periodoGozo: 'Período de Gozo',
      periodoAbonoPecuniario: 'Período do Abono Pecuniário',
      periodoInicioFim: '{inicio} à {fim}',
      empregador: 'Empregador',
      colaborador: 'Trabalhador',
      normal: 'Normal',
      perdida: 'Perdida',
      vencimentos: 'Vencimentos',
      descontos: 'Descontos',
      totalVencimento: 'Total de Vencimentos',
      totalDesconto: 'Total de Descontos',
      valorLiquido: 'Valor Líquido',
      detalhes: 'Detalhes',
      faltasDescontadas: 'Faltas Descontadas',
      salarioContratual: 'Salário Contratual',
      salarioBaseCalculo: 'Salário da Base de Cálculo',
      salarioVariavelBaseCalculo: 'Salário Variável da Base de Cálculo',
      baseCalculo: 'Base de Cálculo das Férias',
      dataAviso: 'Data do Aviso',
      faltas: 'Faltas',
      totalDiasAfastado: 'Dias Afastado',
      totalDiasFalta: 'Faltas Injustificadas',
      checksum: 'Checksum',
      firstViewDatetime: 'Visualizado em'
    },
    description: {
      normal: 'De acordo com o artigo 135 da CLT, através do presente, o empregador vem notificar, com antecedência mínima de 30 dias, que concederá férias no período de gozo abaixo informado.',
      perdida: 'De acordo com o artigo 130 da CLT, através do presente, o empregador vem notificar a perda do direito às férias no período aquisitivo abaixo informado.'
    }
  },
  feriasSnapshotUserContext: {
    title: 'Aviso de Férias',
    pluralTitle: 'Avisos de Férias'
  },
  empregador: {
    field: {
      razaoSocial: 'Razão Social'
    },
    value: {
      tipoInscricao: {
        CPF: 'CPF',
        CNPJ: 'CNPJ'
      }
    }
  },
  colaborador: {
    field: {
      nome: 'Nome',
      cbo: 'CBO',
      ctps: 'CTPS',
      pis: 'PIS',
      cpf: 'CPF',
      nascimento: 'Nascimento',
      admissao: 'Admissão',
      local: 'Local de Trabalho',
      departamento: 'Departamento',
      setor: 'Setor',
      secao: 'Seção'
    }
  }
}

export default flpPtBrLocaleMessages